import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

import auditTheme from "./theme/auditTheme";
import AuditList from "./pages/AuditList";
import AuditNew from "./pages/AuditNew";
import AuditDetail from "./pages/AuditDetail";
import AuditStats from "./pages/AuditStats";
import AuditLog from "./pages/AuditLog";
import { useAuditUser } from "./hooks/useAuditUser";

export default function AuditRouter() {
    const { tieneAcceso } = useAuditUser();

    if (!tieneAcceso) {
        return (
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography color="error" variant="h6">
                    No tenés permisos para acceder a este módulo.
                </Typography>
            </Box>
        );
    }

    return (
        <ThemeProvider theme={auditTheme}>
            <Routes>
                <Route index element={<AuditList />} />
                <Route path="nuevo" element={<AuditNew />} />
                <Route path="estadisticas" element={<AuditStats />} />
                <Route path="log" element={<AuditLog />} />
                <Route path=":id" element={<AuditDetail />} />
                <Route path="*" element={<Navigate to="" replace />} />
            </Routes>
        </ThemeProvider>
    );
}